import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { UIListtState } from './UI.List';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    fields:any={};
    selectedRows:Array<any>=[];
    selectedRowKeys:Array<any>=[];
    pageSize:number=10;
    pageNum:number=1;
    list:any=null;
    companyName:string='';

    //
    uiListtState:UIListtState = new UIListtState();
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/Modules.State.ts